import { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { AuthShell, Field } from "./AuthShell";
import api, { formatApiError } from "@/lib/api";

export default function Signup() {
  const [params] = useSearchParams();
  const [form, setForm] = useState({
    full_name: "", email: "", mobile: "", password: "", confirm_password: "",
    referral_code: params.get("ref") || "",
  });
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    const ref = params.get("ref");
    if (ref) setForm((f) => ({ ...f, referral_code: ref }));
  }, [params]);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm_password) return toast.error("Passwords do not match");
    if (form.password.length < 8) return toast.error("Password must be at least 8 characters");
    setLoading(true);
    try {
      await api.post("/auth/register", form);
      toast.success("Account created! Please log in.");
      nav("/login");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Create your account" subtitle="Join AI TECHNOLOGY in a few steps"
      footer={<>Already have an account? <Link to="/login" className="text-cyan-400 hover:underline" data-testid="signup-to-login">Login</Link></>}>
      <form onSubmit={submit} className="space-y-4">
        <Field label="Full Name" testId="signup-fullname" required value={form.full_name} onChange={set("full_name")} placeholder="John Doe" />
        <Field label="Email" testId="signup-email" type="email" required value={form.email} onChange={set("email")} placeholder="you@example.com" />
        <Field label="Mobile Number" testId="signup-mobile" required value={form.mobile} onChange={set("mobile")} placeholder="+1 555 000 0000" />
        <div className="grid grid-cols-2 gap-3">
          <Field label="Password" testId="signup-password" type="password" required value={form.password} onChange={set("password")} placeholder="Min 8 chars" />
          <Field label="Confirm" testId="signup-confirm" type="password" required value={form.confirm_password} onChange={set("confirm_password")} placeholder="Repeat" />
        </div>
        <Field label="Referral Code (optional)" testId="signup-referral" value={form.referral_code} onChange={set("referral_code")} placeholder="AITXXXXXX" />
        <button type="submit" disabled={loading} data-testid="signup-submit"
          className="btn-glow w-full py-3 rounded-lg font-semibold text-slate-950 inline-flex items-center justify-center gap-2 disabled:opacity-60">
          {loading && <Loader2 className="w-4 h-4 animate-spin" />} Create Account
        </button>
        <p className="text-xs text-slate-500 text-center">By signing up you agree to our <Link to="/terms" className="text-cyan-400">Terms</Link> and <Link to="/risk-disclosure" className="text-cyan-400">Risk Disclosure</Link>.</p>
      </form>
    </AuthShell>
  );
}
